import React from "react";
import { Hero } from "../components/Hero";
import {
  TrustStrip, EditorialMarquee, BuyersSellers, WhyUs, HowItWorks,
  AvailableLots, Reviews, ContactSection, FinalCTA,
} from "../components/Sections";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustStrip />
      <EditorialMarquee />
      <BuyersSellers />
      <WhyUs />
      <HowItWorks />
      <AvailableLots />
      <Reviews />
      <ContactSection />
      <FinalCTA />
    </main>
  );
}
